import SessionsRepository from "../repository/SessionsRepository";
import SessionsService from "../services/SessionsService";
import useFetch from "./utils/useFetch";

const sessionsQuery = Object.freeze({
  byId: "getSessionsById",
  report: "getSessionReport",
  bySectionId: "getSessionBySectionId",
  byStudentId: "getSessionsByStudentId",
  progress: "getAssessmentProgress",
});

const queryFunctions = {
  getSessionsById: async (sessionsService, options) => {
    return await sessionsService.getSessionsById(options);
  },
  getSessionReport: async (sessionsService, options) => {
    return await sessionsService.getSessionReport(options);
  },
  getSessionBySectionId: async (sessionsService, options) => {
    return await sessionsService.getSessionBySectionId(options);
  },
  getSessionsByStudentId: async (sessionsService, options) => {
    return await sessionsService.getSessionsByStudentId(options);
  },
  getAssessmentProgress: async (sessionsService, options) => {
    if (!options?.studentId || !options?.classroomId) return null;
    return await sessionsService.getAssessmentProgress(
      options.studentId,
      options.classroomId
    );
  },
};

const fetchData = async (query, options) => {
  const sessionsRepository = new SessionsRepository();
  const sessionsService = new SessionsService(sessionsRepository);

  const queryFunction = queryFunctions[query];

  if (!queryFunction) {
    throw new Error("Invalid query");
  }

  return await queryFunction(sessionsService, options);
};

const useSessions = (query, options) => {
  const {
    data: sessionsData,
    isLoading: isSessionsLoading,
    error: sessionsError,
  } = useFetch(() => fetchData(query, options));
  return { isSessionsLoading, sessionsError, sessionsData };
};

export { useSessions, sessionsQuery };
